import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addAIMTSyllabusAsync,
  getAllAIMTSyllabusAsync,
  getAIMTSyllabusByIdAsync,
  updateAIMTSyllabusAsync,
  deleteAIMTSyllabusByIdAsync,
  addAIMTAboutAsync,
  getAllAIMTAboutAsync,
  getAIMTAboutByIdAsync,
  updateAIMTAboutAsync,
  deleteAIMTAboutByIdAsync,
} from "./syllabusmocktest.async";

const initialState = {
  syllabusMockTestLoader: false,
  getAllMockTestSyllabus: [],
  syllabusMockTestCreate: [],
  syllabusMockTestId: [],
  syllabusMockTestUpdate: [],
  syllabusMockTestDelete: [],
  aboutMockTestLoader: false,
  getAllMockTestAbout: [],
  aboutMockTestCreate: [],
  aboutMockTestId: [],
  aboutMockTestUpdate: [],
  aboutMockTestDelete: [],
};

export const syllabusmocktestSlice = createSlice({
  name: "syllabus",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllAIMTSyllabusAsync.pending,
        addAIMTSyllabusAsync.pending,
        getAIMTSyllabusByIdAsync.pending,
        updateAIMTSyllabusAsync.pending,
        deleteAIMTSyllabusByIdAsync.pending
      ),
      (state) => {
        state.syllabusMockTestLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllAIMTSyllabusAsync.fulfilled),
      (state, action) => {
        state.syllabusMockTestLoader = false;
        state.getAllMockTestSyllabus = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(addAIMTSyllabusAsync.fulfilled),
      (state, action) => {
        state.syllabusMockTestLoader = false;
        state.syllabusMockTestCreate = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getAIMTSyllabusByIdAsync.fulfilled),
      (state, action) => {
        state.syllabusMockTestLoader = false;
        state.syllabusMockTestId = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(deleteAIMTSyllabusByIdAsync.fulfilled),
      (state, action) => {
        state.syllabusMockTestLoader = false;
        state.syllabusMockTestDelete = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateAIMTSyllabusAsync.fulfilled),
      (state, action) => {
        state.syllabusMockTestLoader = false;
        state.syllabusMockTestUpdate = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllAIMTSyllabusAsync.rejected,
        addAIMTSyllabusAsync.rejected,
        getAIMTSyllabusByIdAsync.rejected,
        updateAIMTSyllabusAsync.rejected,
        deleteAIMTSyllabusByIdAsync.rejected
      ),
      (state, action) => {
        state.syllabusMockTestLoader = false;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllAIMTAboutAsync.pending,
        addAIMTAboutAsync.pending,
        getAIMTAboutByIdAsync.pending,
        updateAIMTAboutAsync.pending,
        deleteAIMTAboutByIdAsync.pending
      ),
      (state) => {
        state.aboutMockTestLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllAIMTAboutAsync.fulfilled),
      (state, action) => {
        state.aboutMockTestLoader = false;
        state.getAllMockTestAbout = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(addAIMTAboutAsync.fulfilled),
      (state, action) => {
        state.aboutMockTestLoader = false;
        state.aboutMockTestCreate = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getAIMTAboutByIdAsync.fulfilled),
      (state, action) => {
        state.aboutMockTestLoader = false;
        state.aboutMockTestId = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(deleteAIMTAboutByIdAsync.fulfilled),
      (state, action) => {
        state.aboutMockTestLoader = false;
        state.aboutMockTestDelete = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateAIMTAboutAsync.fulfilled),
      (state, action) => {
        state.aboutMockTestLoader = false;
        state.aboutMockTestUpdate = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllAIMTAboutAsync.rejected,
        addAIMTAboutAsync.rejected,
        getAIMTAboutByIdAsync.rejected,
        updateAIMTAboutAsync.rejected,
        deleteAIMTAboutByIdAsync.rejected
      ),
      (state, action) => {
        state.aboutMockTestLoader = false;
      }
    );
  },
  reducers: {
    emptySyllabusMockTest: (state) => initialState,
  },
});

export const { emptySyllabusMockTest } = syllabusmocktestSlice.actions;

export default syllabusmocktestSlice.reducer;
